import bootstrap from './bootstrap';
import services from './services';
import config from './config';

export default () => ({
  bootstrap,
  config,
  services,
});
